import {PortfolioSummary} from "../../models/Portfolio";

export class TicketController {

    /** @ngInject */
    constructor(public portfolio: PortfolioSummary,
                public whatIf: any,
                public today: any,
                public isAdviserMode: boolean,
                public fromTradeIdea: boolean) {
    }
}
